import React from "react";

import { formatDecimal2 } from "~/utils";
import { formatDate } from "~/utils/bodyWeightFormatters";
import { HealthBreakdown } from "../Shared";

interface BodyWeightData {
  date: string;
  value: number;
}

interface HourlyBodyWeightData {
  datetime: string;
  hour: number;
  value: number;
}

type TimeRange = "1d" | "7d" | "1m" | "6m" | "1y";

interface BodyWeightBreakdownProps {
  selectedRange: TimeRange;
  filteredData: (BodyWeightData | HourlyBodyWeightData)[];
  breakdownTitle: string;
  loading: boolean;
  error: string | null;
}

export const BodyWeightBreakdown: React.FC<BodyWeightBreakdownProps> = ({
  selectedRange,
  filteredData,
  breakdownTitle,
  loading,
  error,
}) => {
  const getKey = (item: BodyWeightData | HourlyBodyWeightData, selectedRange: TimeRange) => {
    return selectedRange === "1d"
      ? (item as HourlyBodyWeightData).datetime
      : (item as BodyWeightData).date;
  };

  const getTimeDisplay = (item: BodyWeightData | HourlyBodyWeightData, selectedRange: TimeRange) => {
    return selectedRange === "1d"
      ? (item as HourlyBodyWeightData).hour + ":00"
      : formatDate((item as BodyWeightData).date, selectedRange);
  };

  const getValues = (item: BodyWeightData | HourlyBodyWeightData) => [
    {
      label: "Weight",
      value: formatDecimal2(item.value),
      color: "#3b82f6", // blue-500
      unit: "lbs",
    },
  ];

  return (
    <HealthBreakdown
      selectedRange={selectedRange}
      filteredData={filteredData}
      breakdownTitle={breakdownTitle}
      loading={loading}
      error={error}
      dataTypeLabel="Body Weight Data"
      getKey={getKey}
      getTimeDisplay={getTimeDisplay}
      getValues={getValues}
      noDataMessage="No body weight data available"
    />
  );
};
